import { OfferType } from "@/components/IKTrendingOffers";
import { getApiUrl, API_BASE_URL } from "@/lib/api-config";
import { getAuthHeaders } from "@/lib/vehicle-api";

export interface OfferItem {
  id: number;
  code: string;
  title: string;
  description: string;
  image_url?: string | null;
  image: string;
  discount_amount: number;
  min_booking_amount: number;
  coupon_type?: string;
  user_type?: string;
  requires_login?: boolean;
  start_date?: string;
  end_date?: string;
}

/** Formats the offer image URL, prefixing relative paths with the API host URL */
export function offerImageUrl(path: string | null | undefined): string {
  if (!path) return "";
  let cleanPath = path;
  if (path.includes("localhost") || path.includes("127.0.0.1")) {
    const storageIndex = path.indexOf("/storage/");
    if (storageIndex !== -1) {
      cleanPath = path.substring(storageIndex);
    }
  }
  let resolvedUrl = cleanPath.startsWith("http")
    ? cleanPath
    : `${API_BASE_URL}${cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`}`;
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    resolvedUrl = resolvedUrl.replace(/^http:/, "https:");
  }
  return resolvedUrl;
}

/** Fetches offers from the backend public API */
export async function fetchOffers(position?: string, limit?: number): Promise<OfferItem[]> {
  const query = new URLSearchParams();
  if (position) query.append("position", position);
  if (limit) query.append("limit", String(limit));
  
  const queryString = query.toString() ? `?${query.toString()}` : "";
  const path = `/api/v1/web/offers${queryString}`;
  const url = getApiUrl(path);
  try {
    const authHeaders = getAuthHeaders();
    const res = await fetch(url, { headers: { Accept: "application/json", ...authHeaders } });
    if (!res.ok) {
      throw new Error(`Failed to fetch offers: ${res.statusText}`);
    }
    const json = await res.json();
    if (!json?.success || !Array.isArray(json?.data)) {
      return [];
    }

    return json.data.map((item: any, index: number) => ({
      id: item.id || index + 1,
      code: item.code || "",
      title: item.title || "",
      description: item.description || "",
      image_url: item.image_url,
      image: offerImageUrl(item.image_url),
      discount_amount: Number(item.discount_amount || 0),
      min_booking_amount: Number(item.min_booking_amount || 0),
      coupon_type: item.coupon_type || "flat",
      user_type: item.user_type || "all",
      requires_login: Boolean(item.requires_login),
      start_date: item.start_date,
      end_date: item.end_date,
    }));
  } catch (err) {
    console.error("Error fetching offers:", err);
    return [];
  }
}
